import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useWeb3Store = defineStore('web3', () => {
  const isConnected = ref(false)
  const account = ref<string | null>(null)
  const chainId = ref<number | null>(null)
  const provider = ref<any>(null)

  const connect = async () => {
    try {
      if (typeof window !== 'undefined' && (window as any).ethereum) {
        const provider = (window as any).ethereum
        const accounts = await provider.request({ method: 'eth_requestAccounts' })
        
        if (accounts.length > 0) {
          account.value = accounts[0]
          isConnected.value = true
          
          const chainId = await provider.request({ method: 'eth_chainId' })
          chainId.value = parseInt(chainId, 16)
        }
      } else {
        console.warn('MetaMask not detected')
      }
    } catch (error) {
      console.error('Error connecting wallet:', error)
    }
  }

  const disconnect = () => {
    isConnected.value = false
    account.value = null
    chainId.value = null
    provider.value = null
  }

  const switchToSepolia = async () => {
    try {
      await provider.value?.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: '0xaa36a7' }] // Sepolia testnet
      })
    } catch (error) {
      console.error('Error switching to Sepolia:', error)
    }
  }

  return {
    isConnected,
    account,
    chainId,
    provider,
    connect,
    disconnect,
    switchToSepolia
  }
})
